// import node package 'pdfjs-dist'
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.js";
pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

document.addEventListener('turbolinks:load', () => {
    const guestStationScreenPreview = document.getElementById('guestStationScreenPreview')
    const sgScreen = document.getElementById('sgScreenGuest')

    const guestStationPreviewLandscapeImage = document.getElementById('guestStationPreviewLandscapeImage')
    let richTextAreas
    //To know if SG is in landscape mode, without this element it is in portrait mode (default)
    const landscapeImageWithText = document.getElementById('landscapeImageWithText')

    const landscapeAudioThumbnail = document.getElementById('landscapeAudioThumbnail')

    const guestStationPreviewWebsite = document.getElementById('guestStationPreviewWebsite')

    const pdfContainer = document.getElementById('pdfContainer')
    const pdfScrollAreaGuest = document.getElementById('pdfScrollAreaGuest')
    const pdfScrollBarGuest = document.getElementById('pdfScrollBarGuest')
    let pdfNumPages
    // pdf load logic
    let loadQueue = Promise.resolve(); //queue pdf loads on resize
    let loadingTask = null; // To track the current PDF loading task
    let latestTaskId = 0; // save current PDF load task id


    if (sgScreen !== null && guestStationScreenPreview !== null) {
        richTextAreas = sgScreen.getElementsByClassName("trix-content")
        if(guestStationPreviewLandscapeImage !== null){
            if (guestStationPreviewLandscapeImage.complete && guestStationPreviewLandscapeImage.naturalWidth !== 0) {
                resize(); //image is loaded
            } else {
                //wait till image is loaded
                guestStationPreviewLandscapeImage.addEventListener('load', resize, { once: true });
            }
        } else {
            resize()
        }

        if (pdfContainer !== null && pdfScrollAreaGuest !== null && pdfScrollBarGuest !== null) {
            showPdfScrollProgress()
        }
    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenWidth = sgScreen.getBoundingClientRect().width
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height
            let usedScreenHeight = currentSgScreenHeight

            // use smaller image for landscape image with text to prevent vertical scroll
            if (landscapeImageWithText !== null) {
                document.addEventListener("wheel", (e) => {changeScrollingDirection(e)}, { passive: false });
                usedScreenHeight -= 10
                landscapeImageWithText.scrollLeft += 10000;
            }

            // resize rotate audioThumbnail
            if (landscapeAudioThumbnail !== null) {
                landscapeAudioThumbnail.style.height = `${currentSgScreenHeight}px`
                landscapeAudioThumbnail.style.width = `${currentSgScreenWidth}px`
            }

            // resize iframe to hide scrollbar
            if (guestStationPreviewWebsite != null) {
                guestStationPreviewWebsite.style.width = `${currentSgScreenWidth + 17}px`
            }

            // resize rotate image (only for landscape)
            if (guestStationPreviewLandscapeImage != null) {
                // Get original size of image
                let imageWidth = guestStationPreviewLandscapeImage.naturalWidth
                if (imageWidth === 0) {
                    imageWidth = 1 //fallback, with 1 usedImageWidth === usedScreenHeight
                }
                let imageHeight = guestStationPreviewLandscapeImage.naturalHeight
                if (imageHeight === 0) {
                    imageHeight = 1 //fallback, with 1 usedImageHeight === usedScreenHeight
                }

                const ratio = Math.min(usedScreenHeight / imageHeight, currentSgScreenWidth / imageWidth);
                const usedImageWidth = imageWidth*ratio
                const usedImageHeight = imageHeight*ratio
                // Set min and max instead of only width, cause sometimes it ignores the width (maybe because of rotated container)
                // Needs both to have the right size for big and small images
                guestStationPreviewLandscapeImage.style.maxWidth = `${usedImageWidth}px`
                guestStationPreviewLandscapeImage.style.maxHeight = `${usedImageHeight}px`
                guestStationPreviewLandscapeImage.style.minWidth = `${usedImageWidth}px`
                guestStationPreviewLandscapeImage.style.minHeight = `${usedImageHeight}px`
            }

            // handle Text and image description
            for (let richTextArea of richTextAreas) {
                let sgLength = (landscapeImageWithText === null ? currentSgScreenHeight : currentSgScreenWidth)

                // change text appearance + size
                richTextArea.style.fontSize = `${sgLength / 42}px`
                richTextArea.style.lineHeight = `${sgLength / 27}px`
                const h1s = richTextArea.getElementsByTagName('h1')
                for (let h1 of h1s) {
                    h1.classList.add('font-bold')
                    h1.style.fontSize = `${sgLength / 30}px`
                }

                if (landscapeImageWithText !== null) {
                    // for landscape image
                    richTextArea.classList.add('guestStationPreviewLandscapeText') // rotates text
                    richTextArea.classList.add("my-5.5p")
                    richTextArea.classList.add("ml-5.5p")

                    // change border of quote for rotated text
                    const blockquotes = richTextArea.getElementsByTagName("blockquote")
                    for (let blockquote of blockquotes) {
                        blockquote.style.borderLeftWidth = `${0}px`
                        blockquote.style.marginLeft = `${0}px`
                        blockquote.style.paddingLeft = `${0}px`

                        blockquote.style.borderTopWidth = `${0.3}em`
                        blockquote.style.marginTop = `${1}%`
                        blockquote.style.paddingTop = `${1}%`
                    }
                    //the width set here will set the height of the rotated view
                    landscapeImageWithText.style.width = `${currentSgScreenWidth/2}px`
                } else {
                    // for portrait image
                    richTextArea.classList.add("mx-5.5p")
                    richTextArea.classList.add("mb-5.5p")
                }
            }

            // resize pdf
            if (pdfContainer !== null) {
                // Cancel the currently running PDF load (if any)
                if (loadingTask) {
                    loadingTask.destroy();
                    loadingTask = null;
                }

                // Generate a new unique ID for the latest resize event
                const currentTaskId = ++latestTaskId;

                // Add a new PDF load task to the queue, ensuring sequential execution.
                // Any outdated tasks (from previous resizes) will be skipped, and only the latest one will run.
                loadQueue = loadQueue.then(() => {
                    //sequential part -one resize after the other

                    // Ignore outdated tasks
                    if (currentTaskId !== latestTaskId) {
                        return; // Ignore outdated tasks
                    }
                    // executes the latest load
                    return loadPdf()
                });
            }
        })
        resizeObserver.observe(sgScreen);
    }

    /**
     * Loads the PDF from the URL specified in the `data-pdf-url` attribute of `pdfPreviewContainer`.
     *
     * This function:
     * - Retrieves the PDF URL dynamically.
     * - Starts a new PDF loading task using `pdfjsLib.getDocument()`.
     * - Returns a promise that resolves when the PDF is fully loaded.
     * - Ensures only the latest PDF is loaded, as older tasks are ignored in the main execution flow.
     */
    function loadPdf() {

        // Clear previous PDF pages
        pdfContainer.innerHTML = "";

        // Start loading the PDF document asynchronously using pdf.js
        const url = pdfContainer.dataset.pdfUrl
        loadingTask = pdfjsLib.getDocument(url)

        // Return a promise that resolves when the PDF is fully loaded
        return loadingTask.promise
            .then(pdf => {

                // set size of scrollbar
                pdfScrollBarGuest.style.height = `${100/pdf.numPages}%`
                pdfNumPages = pdf.numPages
                if (pdfNumPages > 1) {
                    pdfScrollAreaGuest.classList.remove('hidden')
                }

                // loop over pages of pdf
                for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                    pdf.getPage(pageNum).then(page => {

                        // get pdf page dimensions
                        const originalViewport = page.getViewport({ scale: 1 });
                        const originalWidth = originalViewport.width;
                        const originalHeight = originalViewport.height;

                        // Get pdfContainer dimensions (already fixed)
                        const pdfContainer = document.getElementById('pdfContainer')

                        // handle running promise after navigating away
                        if (pdfContainer == null) {
                            return
                        }

                        const containerWidth  = pdfContainer.getBoundingClientRect().width;
                        const containerHeight  = pdfContainer.getBoundingClientRect().height;

                        // Calculate scale to fit while maintaining aspect ratio
                        const scaleX = containerWidth / originalWidth;
                        const scaleY = containerHeight / originalHeight;
                        const scale =  Math.min(scaleX, scaleY) ; // Use the smaller scale to avoid distortion

                        // Create a newCanvas inside pdfContainer
                        const newCanvas = document.createElement("canvas");
                        newCanvas.classList.add("pdfCanvasPage")
                        const context = newCanvas.getContext("2d");

                        // Compute the new viewport with correct scaling
                        const scaledViewport = page.getViewport({ scale });

                        // Set the newCanvas dimensions based on scaled PDF size
                        newCanvas.width = scaledViewport.width;
                        newCanvas.height = scaledViewport.height;

                        // set padding to center pages
                        const marginToCenter = (containerHeight - scaledViewport.height)/2
                        newCanvas.style.paddingTop = `${marginToCenter}px`
                        newCanvas.style.paddingBottom = `${marginToCenter}px`

                        // Append newCanvas to the div container
                        pdfContainer.appendChild(newCanvas);

                        // Render PDF on newCanvas
                        const renderContext = {
                            canvasContext: context,
                            viewport: scaledViewport
                        };

                        page.render(renderContext)
                    })
                }
            })
            .catch(() => {
                // handle destroy of task without exception
            })
            .finally(() => {
                loadingTask = null;
            })
    }

    /**
     * Attaches a scroll listener to the PDF container to update the vertical position of the custom scrollbar.
     *
     * The scrollbar indicator (pdfScrollBarGuest) reflects the user's current scroll progress through the PDF.
     * If the total number of pages (pdfNumPages) is known, the indicator's position is adjusted so that
     * it stays aligned proportionally, accounting for the height each page would occupy.
     */
    function showPdfScrollProgress() {
        console.log("init")
        pdfContainer.addEventListener('scroll', () => {
            console.log("scroll")
            const scrollTop = pdfContainer.scrollTop;
            const scrollHeight = pdfContainer.scrollHeight;
            const clientHeight = pdfContainer.clientHeight;

            const scrollProgress = (scrollTop / (scrollHeight - clientHeight)) * 100;
            if (pdfNumPages !== null) { // set inside loadGuideDetailPdf
                console.log(pdfScrollBarGuest)
                pdfScrollBarGuest.style.top = `${scrollProgress-(scrollProgress* (1.0/pdfNumPages))}%`;
            }


        });
    }

    // #landscapeImageWithText is rotated, so the Default scrolling is rotated,too.
    // Change it to the normal behaviour to scroll up/down with the mousewheel
    function changeScrollingDirection(event){
        //Only do something if the element is inside landscapeImageWithText
        if (event.target.closest('#landscapeImageWithText')){
            landscapeImageWithText.scrollLeft -= event.deltaY * 0.2;
            event.preventDefault()
        }
    }

});